import { PQR_TIMES_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const usePqrTimesListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${PQR_TIMES_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
